export var FLAG_NAMES = {
  WPLT_FLAGS: {
    ACC_PROJECT_PROFILE_ADDITIONAL_FIELDS: 'acc-project-profile-additional-fields',
    CREATE_PROJECT_REDIRECT_PA_CONSOLE: 'create-project-redirect-pa-console',
    INVITE_PROJECT_MEMBER_ALLOW_REINVITING: 'invite-project-member-allow-reinviting',
    INVITE_PROJECT_MEMBER_SHOW_PRODUCTS: 'invite-project-member-show-products',
    PL_PROJECT_TEMPLATES_MAINTENANCE_MODE: 'PL_PROJECT_TEMPLATES_MAINTENANCE_MODE'
  },
  ADMIN_FLAGS: {
    ACC_DISABLE_MANAGE_COST_ACCESS_FOR_PROJECT_ADMINS: 'acc-disable-manage-cost-access-for-project-admins',
    ACC_REPLACE_GET_CONSTRUCTION_APIS: 'acc-replace-get-construction-apis',
    ACC_REPLACE_WRITE_CONSTRUCTION_APIS: 'acc-replace-write-construction-apis',
    ACC_ENABLE_ADD_COMPANY_DEBOUNCE: 'acc-enable-add-company-debounce',
    ACC_USE_PROJECT_ENTITLEMENTS_V2: 'use-project-entitlements-v2-endpoint',
    ENABLE_OFFERINGS_CONTAINABILITY: 'enable-offerings-containability',
    ENABLE_PROJECT_ROLES_PRODUCTS: 'enable-project-roles-products',
    ENABLE_PRODUCT_ACCESS_IN_PROJECT_CREATION: 'enable-product-access-in-project-creation',
    PRODUCTS_SECTION_REDESIGN: 'acc-products-section-redesign',
    SET_DEFAULT_COMPANY_AND_ROLES: 'acc-project-user-set-default-company-and-roles',
    SHOW_CATEGORIZED_SETTINGS: 'acc-project-admin-settings-categorized-details',
    SHOW_LOCATIONS: 'acc-project-admin-locations-tab',
    SHOW_NOTIFICATIONS: 'acc-project-admin-notifications-tab',
    USE_ISSUES_NEW_PERMISSION_LEVELS: 'use-issues-new-permission-levels'
  }
};
//# sourceMappingURL=flagNames.js.map